<template>
	<div>
		<v-divider></v-divider>
		<div class="pa-2">
			<v-row
				class="mb-2"
				align="center"
				dense
			>
				<v-col
					cols="6"
					sm="4"
					md="2"
				>
					<v-autocomplete
						v-model="employeeIds" 
						:items="[]"
						item-text="name"
						item-value="id"
						dense
						outlined
						hide-details
						multiple
						label="اسم الموظف"
						:disabled="loading"
					/>
				</v-col>
				<v-col
					cols="6"
					sm="4"
					md="2">
					<v-autocomplete
						v-model="searchSection"
						:items="[]"
						clearable
						dense
						outlined
						label="نوع التقييم"
						hide-details
						:disabled="loading"
						></v-autocomplete>
				</v-col>

				<v-col lg="2" md="3" sm="4" cols="6">
					<v-text-field
						v-model="fromDate"
						label="من تاريخ"
						outlined
						dense
						hide-details
						:disabled="loading"
					/>
				</v-col>

				<v-col lg="2" md="3" sm="4" cols="6">
					<v-text-field
						v-model="toDate"
						label="إلى تاريخ"
						outlined
						dense
						hide-details
						:disabled="loading"
					/>
				</v-col>
				<v-col cols="auto">
					<v-btn
						:disabled="!(employeeIds.length || searchSection || loading)"
						class="me-1"
						outlined
						small
						color="primary"
						>
						<v-icon
							small
							left>
							mdi-magnify
						</v-icon>
						{{ $T('default-buttons.search') }}
					</v-btn>
					<v-btn
						v-if="!!(employeeIds.length || searchSection || loading)"
						@click="clearFilters"
						style="min-width: 30px"
						class="px-0"
						outlined
						small
						color="alert">
						<v-icon small> $clear </v-icon>
					</v-btn>
				</v-col>

				<v-spacer></v-spacer>
				<v-divider
					vertical
					class="mx-1"></v-divider>
				<v-col cols="auto">
					<v-btn
						:to="{ name: 'add-interview' }"
						color="primary"
						small
						:disabled="loading">
						<v-icon
							size="20"
							left>
							$add
						</v-icon>
						{{ $T('add') }}
					</v-btn>
				</v-col>
			</v-row>
			<bee-handy-table
				ref="table"
				class="with-sex"
				:headers="tableHeaders"
				:items="items"
				:data-table-props="{ disableSort: true }"
				dense
				zebra
				fixed-header
				:height="$vuetify.breakpoint.height - 120"
				:row-highlight-expression="(e) => e.sex === 'female'"
				:row-highlight-expression-class="'female-row'"
				hide-default-footer

				pagination-on-scroll
				:pagination-on-scroll-auto-reset-shown="false"
            	pagination-on-scroll-server-items
				:items-per-page="20"
				:options-scroll.sync="optionsScroll"
				:server-items-length="serverItemsLength"
            	@pagination-on-scroll:reach-last-row="getEvaluation"
				:loading="loading"	
				
			>
				<template v-slot:item.name="{ value }">
					<div class="d-flex align-center">
						<v-img
							src="@/assets/Untitled.jpg"
							max-height="2rem"
							max-width="2rem"
							class="ml-2"></v-img>
						{{ value }}
					</div>
				</template>
				<template v-slot:item.actions>
					<tooltip :text="$T('tooltips.preview')">
						<v-btn
							small
							icon
							@click="
								addDialog = true;
								itemId = 1;
							">
							<v-icon
								size="20"
								color="preview">
								$view
							</v-icon>
						</v-btn>
					</tooltip>
				</template>
			</bee-handy-table>
		</div>

		<!-- add dialog -->
		<v-dialog
			v-model="addDialog"
			max-width="400">
			<v-card>
				<v-form>
					<v-card-title>
						<span>
							{{ `${!itemId ? $T('add') : $T('edit')} ${$T('interviews')}` }}
						</span>
						<v-spacer />
						<v-btn
							icon
							@click="addDialog = false">
							<v-icon>$close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row dense>
							<v-col cols="12">
								<v-autocomplete
									v-model="addInterviews.name"
									:items="employees"
									multiple
									return-object
									item-value="code"
									:label="$T('inputs.employee-name')"
									:filter="
										(item, queryText) =>
											item.code.includes(queryText) || item.name.includes(queryText)
									"
									dense
									outlined
									hide-details>
									<template v-slot:item="{ item }">
										<div
											class="d-flex justify-space-between text-caption"
											style="width: 100%">
											<div>
												({{ item.code }})
												{{ item.name }}
											</div>
											<div>
												{{ item.section }}
											</div>
										</div>
									</template>
									<template v-slot:selection="{ item, index }">
										<div
											v-if="index < 5"
											class="d-flex justify-space-between"
											style="min-width: 100%">
											<div>
												({{ item.code }})
												{{ item.name }}
											</div>
											<div>
												{{ item.section }}
											</div>
										</div>
										<span
											v-if="index === 5"
											class="text-caption text-start"
											style="width: 100%">
											+{{ employee?.length - 5 }}
											موظف اخرون
										</span>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="addInterviews.interviewsName"
									:label="$T('inputs.interviewsName')"
									dense
									outlined
									hide-details="auto"></v-text-field>
							</v-col>
							<v-col cols="12">
								<bee-date-picker
									v-model="addInterviews.interviewsDate"
									:input-label="$T('inputs.interviewsDate')"
									outlined
									menu-picker
									:input-props="{
										outlined: true,
										dense: true,
										prependInnerIcon: '$calendar',
									}"
									no-title
									dense
									hide-details></bee-date-picker>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn
							color="secondary"
							@click="addDialog = false">
							{{ $T('default-buttons.save') }}
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment, { DATE_FORMAT } from '@/utils/moment';

export default {
	name: 'Interviews',

	data() {
		return {
			itemId: null,

			addDialog: false,

			employeeIds: [],
			searchSection: null,
			searchType: null,

			searchDate: new Date().toISOString().slice(0, 7),

			addInterviews: {
				name: null,
				section: null,
				interviewsName: null,
				interviewsDate: null,
			},


			tableHeaders: [
				{
					text: this.$T('headers.employee-name'),
					name: 'employee',
					value: 'employee.arabicFullName',
				},
				{
					text: this.$T('headers.section-name'),
					name: 'employee',
					value: 'employee.sectionName',
				},
				{
					text: this.$T('headers.interviewsName'),
					name: 'interviewsName',
					value: 'interviewsName',
				},
				{
					text: this.$T('headers.interviewsDate'),
					name: 'date',
					value: 'date',
					type: 'date',
					dateFormat: DATE_FORMAT,
				},
				{ text: '', name: 'actions', value: 'actions', width: 20 },
			],

			//! to delete
			// items: [
			// 	{
			// 		name: 'محمد العلي',
			// 		section: 'قسم المعلوماتية',
			// 		interviewsName: 'تقييم سنوي',
			// 		interviewsDate: new Date(),
			// 		sex: 'male',
			// 	},
			// 	{
			// 		name: 'مها الباشا',
			// 		section: 'قسم المكيانيك',
			// 		interviewsName: 'تقييم مقابلة',
			// 		interviewsDate: new Date(),
			// 		sex: 'female',
			// 	},
			// 	{
			// 		name: 'علي الاغا',
			// 		section: 'الخياطة',
			// 		interviewsName: 'تقييم خلال فترة تجريب',
			// 		interviewsDate: new Date(),
			// 		sex: 'male',
			// 	},
			// 	{
			// 		name: 'محمد احمد العمري',
			// 		section: 'قسم المعلوماتية',
			// 		interviewsName: 'تقييم سنوي',
			// 		interviewsDate: new Date(),
			// 		sex: 'male',
			// 	},
			// ],
			employees: [
				{ code: '10-191', name: 'محمد الاحمد', section: 'قسم الميكانيك' },
				{ code: '25-252', name: 'امجد درعوزي', section: 'قسم المعلوماتية' },
				{ code: '23-343', name: 'علي اغا', section: 'قسم الخياطة' },
				{ code: '10-1911', name: 'محمد الاحمد', section: 'قسم الميكانيك' },
				{ code: '25-2521', name: 'امجد درعوزي', section: 'قسم المعلوماتية' },
				{ code: '23-3431', name: 'علي اغا', section: 'قسم الخياطة' },
				{ code: '10-1912', name: 'محمد الاحمد', section: 'قسم الميكانيك' },
				{ code: '25-2522', name: 'امجد درعوزي', section: 'قسم المعلوماتية' },
				{ code: '23-3432', name: 'علي اغا', section: 'قسم الخياطة' },
			],
			sections: ['قسم الميكانيك', 'قسم المعلوماتية', 'قسم الخياطة'],
			fromDate: moment(moment().startOf('month')).format('YYYY-MM-DD'),
			toDate: moment(moment().endOf('month')).format('YYYY-MM-DD'),
			serverItemsLength: 0,
			optionsScroll: {},
			loading: false
		};
	},

	methods: {
		moment,
		clearFilters() {
			this.employeeIds = [];
			this.searchSection = null;
		},
		getEvaluation(newOptionsScroll) {
			this.loading = true
			let page = 1
			if (newOptionsScroll) {
                page = newOptionsScroll.page;
            }
			this.$store.dispatch('evaluation/fetchEvaluation', { 
				fromDate: this.fromDate,
				toDate: this.toDate,
				employeeIds: this.employeeIds,
				page: page
			}).then(({ data, total }) => {
				if (this.needToResetShownRows) {
					this.$refs.table.resetShownRows();
					this.needToResetShownRows = false
				}
				this.$refs.table.addScrollItems(data)
				this.serverItemsLength = total;
			}).finally(() => {
				this.loading = false
			})
		}
	},

	created() {
		// this.getEvaluation()
	}
};
</script>

<style lang="scss" scoped></style>
